import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=757a64b4"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"
import style0 from "./Headline.vue?vue&type=style&index=0&id=757a64b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports